import { render, staticRenderFns } from "./staffTransfer.vue?vue&type=template&id=3e0d36ae&scoped=true&"
import script from "./staffTransfer.vue?vue&type=script&lang=js&"
export * from "./staffTransfer.vue?vue&type=script&lang=js&"
import style0 from "./staffTransfer.vue?vue&type=style&index=0&id=3e0d36ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0d36ae",
  null
  
)

export default component.exports